import React from 'react'
import Link from 'gatsby-link'
import Menu from '../Menu'

const renderedItems = [];

const Navigation = ( { pages, pathContext } ) => {

  const drawerMenuItems = pages.edges.filter((page) => {
    return page.node.context.parent;
  });

  const topMenuItems = pages.edges.filter((page) => {
    return !page.node.context.parent;
  });

  const groupedArray = topMenuItems.map(item => {
    return drawerMenuItems.filter(drawerItem => {
      const regex = new RegExp('^' + item.node.context.index + '-');
      return drawerItem.node.context.index.match(regex);
    });
  });

  return (
    <div className="navigation-menu">
      <div className="navigation-container">
      {groupedArray.map(group => {
        const key = group.length > 0 ? `nav-${group[0].node.id}` : '';
        return <Menu key={key} nodes={group} pages={pages} withChildren={true} pathContext={pathContext} />
      })}
      </div>
    </div>
  );
}

export default Navigation



// WEBPACK FOOTER //
// ./src/components/Navigation/index.js